import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import { WbCardContent } from '../WbCard';
import {
  WbDockableGroup,
  WbDockablePanel,
  WbDockableResizeHandle,
} from '../WbDockable';
import { useMultiSelectionPickerContext } from './MultiSelectionPickerContext';
import { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import { SelectedValues } from './SelectedEntities';

interface ContentProps {
  setOpen: Dispatch<SetStateAction<boolean>>;
  children?: ReactNode;
  title?: string;
  aiEnabled?: boolean;
  contentHeader?: JSX.Element;
  contentHeight?: string;

  aiToggleComponent?: React.ReactNode;
}

const useStyles = makeStyles<Theme, { contentHeight: string }>(
  theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: props => props.contentHeight,
      maxHeight: props => props.contentHeight,
      overflow: 'hidden',
      padding: 0,
      flex: 1,
    },
    cardContent: {
      padding: theme.spacing(0),
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    childrenBox: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    aiFilterButton: {
      marginTop: theme.spacing(1),
      width: 'fit-content',
      border: 'solid 1px transparent',
      borderRadius: '4px',
      background:
        'linear-gradient( #ffffff, #ffffff) padding-box,linear-gradient(90deg, #EE72D3, #7C4DFF) border-box',
    },
    dialogActions: {
      padding: theme.spacing(1),
      position: 'sticky',
      bottom: 0,
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      background: theme.palette.white,
    },
  }),
  { name: 'MultiSelection-content' },
);

export const MultiSelectionContent: FC<ContentProps> = ({
  children,
  title,
  contentHeader,
  contentHeight = '100%',
  aiToggleComponent,
}) => {
  const classes = useStyles({ contentHeight });
  const { contextSelected, setContextSelected } =
    useMultiSelectionPickerContext();

  return (
    <WbCardContent className={classes.root}>
      <WbDockableGroup direction="horizontal">
        <WbDockablePanel defaultSize={70}>
          <WbCardContent className={classes.cardContent}>
            {contentHeader
              ? contentHeader
              : title && (
                  <Box className={classes.title}>
                    <Typography variant="body1" style={{ fontWeight: '700' }}>
                      {title}
                    </Typography>
                  </Box>
                )}

            {aiToggleComponent}

            <Box className={classes.childrenBox}>
              {/* left content */}
              {children}
            </Box>
          </WbCardContent>
        </WbDockablePanel>

        <WbDockableResizeHandle
          showIconOnHover
          divider
          size={4}
          direction="horizontal"
        />

        <WbDockablePanel maxSize={30}>
          <SelectedValues
            values={contextSelected}
            setValues={setContextSelected}
          />
        </WbDockablePanel>
      </WbDockableGroup>
    </WbCardContent>
  );
};
